var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-select", {
    attrs: {
      value: _vm.value,
      "allow-clear": "",
      "show-search": "",
      "filter-option": false,
      loading: _vm.loading,
      "dropdown-match-select-width": false,
      disabled: _vm.disabled,
      placeholder: _vm.$t("common.select-text", {
        text: _vm.$t("lbl_sales_name")
      }),
      "label-in-value": "",
      options: _vm.options
    },
    on: { search: _vm.onSearch, change: _vm.onChange }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }